module.exports = __webpack_public_path__ + "static/philippe_gouillart-0c6760fda60b91b404d231b1f813c698.png";